<dx-popup
    #userPopup
    [title]="title"
    width="20%"
    height="60%"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="true"
    [(visible)]="visible"
    (onHidden)="onHidden()"
    (onShown)="onShown()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-list
            selectionMode="none"
            pageLoadMode="scrollBottom"
            searchExpr="displayName"
            [dataSource]="users"
            [noDataText]="noDataText"
            [searchEnabled]="true"
            [focusStateEnabled]="false"
            [activeStateEnabled]="false"
            [hoverStateEnabled]="false"
        >
            <div *dxTemplate="let user of 'item'" class="responsibleusers-listitem">
                <app-user-bio-link [user]="user" [communityId]="communityId"></app-user-bio-link>
            </div>
        </dx-list>
    </div>
</dx-popup>
